<template>
  <div class="terminos-wrapper">
    <h3 class="terminos-titulo">Términos y Condiciones</h3>
    <h4 class="terminos-subtitulo">Evolve Grappling Pro — Compra de Boletos</h4>

    <div class="terminos-box">
      <div class="terminos-seccion">
        <h5>1. Adquisición de boletos</h5>
        <p>
          Al realizar una compra en Evolve Grappling Pro confirmas que has leído y aceptas
          estos términos. Cada boleto adquirido es personal e intransferible y otorga
          acceso al evento en la modalidad seleccionada (General, Primera Fila, Mesa VIP o
          Streaming).
        </p>
      </div>

      <div class="terminos-seccion">
        <h5>2. Proceso de registro de invitados</h5>
        <p>
          Si adquieres más de un boleto, recibirás un correo con tu confirmación y un
          enlace individual por cada boleto adicional. Cada invitado deberá registrarse
          con sus datos personales para recibir su código QR de acceso. Para menores de
          edad se requerirá una fotografía de identificación.
        </p>
      </div>

      <div class="terminos-seccion">
        <h5>3. Acceso al evento presencial</h5>
        <p>
          El acceso al recinto se realizará únicamente mediante la presentación del código
          QR recibido por correo electrónico. Opcionalmente se podrá solicitar una
          identificación oficial. Evolve Grappling Pro se reserva el derecho de negar el
          acceso a personas que no cuenten con su QR registrado o que presenten
          comportamientos inapropiados.
        </p>
      </div>

      <div class="terminos-seccion">
        <h5>4. Acceso Streaming</h5>
        <p>
          Los boletos de tipo Streaming otorgan acceso a la transmisión en vivo del evento
          a través de la plataforma oficial. Las credenciales de acceso (correo y
          contraseña) serán enviadas al correo registrado una vez completado el proceso de
          asignación. El acceso permite un máximo de una sesión simultánea por boleto. El
          acceso expirará dos horas después de la hora de finalización del evento.
        </p>
      </div>

      <div class="terminos-seccion">
        <h5>5. Política de reembolsos</h5>
        <p>
          Una vez procesado el pago, los boletos no son reembolsables salvo cancelación
          del evento por parte de los organizadores. En caso de cancelación, se realizará
          el reembolso íntegro al método de pago original en un plazo de 5 a 10 días
          hábiles.
        </p>
      </div>

      <div class="terminos-seccion">
        <h5>6. Procesamiento de pagos</h5>
        <p>
          Todos los pagos son procesados de forma segura a través de
          <strong>Stripe</strong>, plataforma certificada con estándar
          <strong>PCI DSS Nivel 1</strong>. Los datos de tu tarjeta nunca son almacenados
          en nuestros servidores. Para más información sobre seguridad de pagos, consulta
          la política de privacidad de Stripe en
          <a href="https://stripe.com/privacy" target="_blank">stripe.com/privacy</a>.
        </p>
      </div>

      <div class="terminos-seccion">
        <h5>7. Privacidad y uso de datos</h5>
        <p>
          Los datos personales recopilados durante el proceso de compra serán utilizados
          exclusivamente para la gestión del evento y el envío de comunicaciones
          relacionadas con el mismo. No compartimos tu información con terceros fuera del
          proceso de pago.
        </p>
      </div>

      <div class="terminos-seccion">
        <h5>8. Modificaciones al evento</h5>
        <p>
          Los organizadores se reservan el derecho de modificar fecha, hora, sede o
          cartelera del evento por causas de fuerza mayor. En estos casos se notificará a
          los compradores por correo electrónico con la mayor anticipación posible.
        </p>
      </div>

      <p class="terminos-contacto">
        ¿Tienes dudas? Contáctanos en
        <a href="mailto:evolvegrapplingpro@coudera.com"
          >evolvegrapplingpro@coudera.com</a
        >
      </p>
    </div>
  </div>
</template>

<style scoped>
.terminos-wrapper {
  padding: 0.5rem 0;
}
.terminos-titulo {
  font-size: 1.15rem;
  font-weight: 800;
  color: #0f172a;
  text-align: center;
  margin-bottom: 4px;
}
.terminos-subtitulo {
  font-size: 0.82rem;
  font-weight: 500;
  color: #64748b;
  text-align: center;
  margin-bottom: 1.2rem;
}
.terminos-box {
  max-height: 420px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.2rem 1.4rem;
  background: #f8fafc;
  line-height: 1.65;
  scrollbar-width: thin;
  scrollbar-color: #c8d8f0 transparent;
}
.terminos-box::-webkit-scrollbar {
  width: 5px;
}
.terminos-box::-webkit-scrollbar-thumb {
  background: #c8d8f0;
  border-radius: 4px;
}
.terminos-seccion {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px dashed #e2e8f0;
}
.terminos-seccion:last-of-type {
  border-bottom: none;
  margin-bottom: 0.5rem;
}
.terminos-seccion h5 {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e40af;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.terminos-seccion p {
  font-size: 0.82rem;
  color: #475569;
  margin: 0;
}
.terminos-seccion a {
  color: #007bff;
}
.terminos-contacto {
  font-size: 0.8rem;
  color: #888;
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 0;
}
.terminos-contacto a {
  color: #007bff;
}

@media (max-width: 576px) {
  .terminos-box {
    padding: 1rem;
    max-height: 360px;
  }
  .terminos-seccion p,
  .terminos-seccion h5 {
    font-size: 0.78rem;
  }
}
</style>
